import {LiveStreamingTileRetryScreenDefaultBox} from "./live-streaming-tile-retry-screen.default.box";

export const LiveStreamingTileRetryScreenBox = LiveStreamingTileRetryScreenDefaultBox;
